import axios from "axios";
import { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import geografiaFunciones from "../function/geografia.Funciones";
import {
  generarEdades,
  generarGruposSanguineos,
  generarSexos,
} from "../function/listascomunes.Funciones";
import { normalizeImage } from "../utils/image";

const MODULO = "Instructores";

const normalizarTexto = (texto = "") =>
  String(texto)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();

const normalizarRol = (texto = "") =>
  String(texto)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, "_");

const limpiarTextoOrden = (texto = "") =>
  String(texto)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

const ordenarPorNombre = (array = [], campo) => {
  return [...array].sort((a, b) => {
    const nombreA = limpiarTextoOrden(a?.[campo]);
    const nombreB = limpiarTextoOrden(b?.[campo]);

    return nombreA.localeCompare(nombreB, "es", {
      sensitivity: "base",
      numeric: true,
      ignorePunctuation: true,
    });
  });
};

const quitarDuplicadosPorNombre = (array = [], campoNombre) => {
  const mapa = new Map();

  array.forEach((item) => {
    const nombreNormalizado = normalizarTexto(item?.[campoNombre] || "");

    if (nombreNormalizado && !mapa.has(nombreNormalizado)) {
      mapa.set(nombreNormalizado, item);
    }
  });

  return Array.from(mapa.values());
};

const RegistrarInstructores = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [documentoInstructor, setDocumentoInstructor] = useState("");
  const [tipodocumentoInstructor, setTipodocumentoInstructor] = useState("");
  const [nombre1Instructor, setNombre1Instructor] = useState("");
  const [nombre2Instructor, setNombre2Instructor] = useState("");
  const [apellido1Instructor, setApellido1Instructor] = useState("");
  const [apellido2Instructor, setApellido2Instructor] = useState("");
  const [fechanacimientoInstructor, setFechanacimientoInstructor] = useState("");
  const [edadInstructor, setEdadInstructor] = useState("");
  const [sexoInstructor, setSexoInstructor] = useState("");
  const [rhInstructor, setRhInstructor] = useState("");
  const [emailInstructor, setEmailInstructor] = useState("");

  const [roles, setRoles] = useState([]);
  const [rolObjectId, setRolObjectId] = useState("");
  const [passwordInstructor, setPasswordInstructor] = useState("");
  const [confirmPasswordInstructor, setConfirmPasswordInstructor] = useState("");
  const [mostrarPassword, setMostrarPassword] = useState(false);
  const [mostrarConfirmPassword, setMostrarConfirmPassword] = useState(false);
  const [loadingRoles, setLoadingRoles] = useState(false);

  const [telefono1Instructor, setTelefono1Instructor] = useState("");
  const [telefono2Instructor, setTelefono2Instructor] = useState("");
  const [direccionInstructor, setDireccionInstructor] = useState("");

  const [paises, setPaises] = useState([]);
  const [estados, setEstados] = useState([]);
  const [ciudades, setCiudades] = useState([]);

  const [paisInstructor, setPaisInstructor] = useState("");
  const [estadoInstructor, setEstadoInstructor] = useState("");
  const [ciudadInstructor, setCiudadInstructor] = useState("");

  const [paisSeleccionado, setPaisSeleccionado] = useState("");
  const [estadoSeleccionado, setEstadoSeleccionado] = useState("");
  const [ciudadSeleccionada, setCiudadSeleccionada] = useState("");

  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState("");
  const previewRef = useRef("");
  const [uploadState, setUploadState] = useState(0);
  const [loading, setLoading] = useState(false);

  const [usuarioSesion, setUsuarioSesion] = useState(null);
  const [verificandoSesion, setVerificandoSesion] = useState(true);

  const edit = Boolean(id);

  const edades = generarEdades();
  const sexos = generarSexos();
  const gruposSanguineos = generarGruposSanguineos();

  const paisesOrdenados = useMemo(
    () => ordenarPorNombre(quitarDuplicadosPorNombre(paises, "nombrePais"), "nombrePais"),
    [paises]
  );

  const estadosOrdenados = useMemo(
    () =>
      ordenarPorNombre(
        quitarDuplicadosPorNombre(estados, "nombreEstado"),
        "nombreEstado"
      ),
    [estados]
  );

  const ciudadesOrdenadas = useMemo(
    () =>
      ordenarPorNombre(
        quitarDuplicadosPorNombre(ciudades, "nombreCiudad"),
        "nombreCiudad"
      ),
    [ciudades]
  );

  const getToken = () =>
    localStorage.getItem("token") || sessionStorage.getItem("token") || "";

  const getHeaders = () => {
    const token = getToken();

    return {
      Authorization: `Bearer ${token}`,
    };
  };

  const decodificarToken = (token) => {
    try {
      if (!token) return {};
      const payload = token.split(".")[1];
      if (!payload) return {};
      return JSON.parse(atob(payload));
    } catch (error) {
      console.error("Token inválido:", error);
      return {};
    }
  };

  const cargarUsuarioSesion = async () => {
    try {
      const token = getToken();

      if (!token) {
        setVerificandoSesion(false);
        return;
      }

      const usuarioToken = decodificarToken(token);

      const instructorId =
        usuarioToken?._id ||
        usuarioToken?.id ||
        usuarioToken?.uid ||
        usuarioToken?.instructorObjectId ||
        usuarioToken?.usuario?._id ||
        usuarioToken?.usuario?.id ||
        "";

      if (!instructorId) {
        console.warn("No se encontró ID del instructor en el token.");
        setVerificandoSesion(false);
        return;
      }

      const { data } = await axios.get(`/api/instructores/listid/${instructorId}`, {
        headers: getHeaders(),
      });

      if (data?.ok) {
        setUsuarioSesion(data.message || {});
      }
    } catch (error) {
      console.error(
        "Error cargando usuario de sesión:",
        error.response?.data || error.message
      );
    } finally {
      setVerificandoSesion(false);
    }
  };

  useEffect(() => {
    cargarUsuarioSesion();
  }, []);

  const esSuperAdmin =
    normalizarRol(usuarioSesion?.rolObjectId?.nombreRol) === "SUPER_ADMIN";

  const puedeAsignarRoles = esSuperAdmin;

  const getModuloInstructores = () => {
    try {
      const permisosStorage = localStorage.getItem("permisos");
      const usuarioStorage = localStorage.getItem("usuario");
      const userStorage = localStorage.getItem("user");
      const usuariosStorage = localStorage.getItem("usuarios");

      const permisosData = permisosStorage
        ? JSON.parse(permisosStorage)
        : usuarioStorage
          ? JSON.parse(usuarioStorage)
          : userStorage
            ? JSON.parse(userStorage)
            : usuariosStorage
              ? JSON.parse(usuariosStorage)
              : {};

      const modulos = Array.isArray(permisosData)
        ? permisosData
        : permisosData?.modulos ||
        permisosData?.permisos ||
        permisosData?.usuario?.modulos ||
        permisosData?.usuario?.permisos ||
        permisosData?.user?.modulos ||
        permisosData?.user?.permisos ||
        [];

      const moduloBuscado = normalizarTexto(MODULO);

      return (
        modulos.find((modulo) => {
          const nombre =
            modulo?.nombreModulo || modulo?.modulo || modulo?.nombre || "";

          return normalizarTexto(nombre) === moduloBuscado;
        }) || {}
      );
    } catch (error) {
      console.error("Error leyendo permisos:", error);
      return {};
    }
  };

  const moduloInstructores = useMemo(() => getModuloInstructores(), []);

  const puedeCrear =
    moduloInstructores?.puedeCrear === true ||
    moduloInstructores?.crear === true ||
    moduloInstructores?.create === true;

  const puedeActualizar =
    moduloInstructores?.puedeActualizar === true ||
    moduloInstructores?.actualizar === true ||
    moduloInstructores?.editar === true ||
    moduloInstructores?.update === true;

  const tienePermisoFormulario = edit ? puedeActualizar : puedeCrear;

  const cleanData = () => {
    setDocumentoInstructor("");
    setTipodocumentoInstructor("");
    setNombre1Instructor("");
    setNombre2Instructor("");
    setApellido1Instructor("");
    setApellido2Instructor("");
    setFechanacimientoInstructor("");
    setEdadInstructor("");
    setSexoInstructor("");
    setRhInstructor("");
    setEmailInstructor("");
    setPasswordInstructor("");
    setConfirmPasswordInstructor("");
    setRolObjectId("");
    setTelefono1Instructor("");
    setTelefono2Instructor("");
    setDireccionInstructor("");
    setPaisInstructor("");
    setEstadoInstructor("");
    setCiudadInstructor("");
    setPaisSeleccionado("");
    setEstadoSeleccionado("");
    setCiudadSeleccionada("");
    setPaises([]);
    setEstados([]);
    setCiudades([]);

    if (preview && preview.startsWith("blob:")) {
      try {
        URL.revokeObjectURL(preview);
      } catch (e) { }
    }

    setImage(null);
    setPreview("");
    previewRef.current = "";

    const fileInput = document.getElementById("fileInput");
    if (fileInput) fileInput.value = "";

    const fileNameInput = document.getElementById("fileName");
    if (fileNameInput) fileNameInput.value = "";

    const label = document.getElementById("fileLabel");
    if (label) label.textContent = "Seleccionar / Cambiar";
  };

  const handleCancelOrClean = () => {
    if (edit) {
      navigate("/instructor/");
    } else {
      cleanData();
    }
  };

  const cargarDatosInstructor = async (instructorData, isMounted = true) => {
    const fechaNacimiento = instructorData.fechanacimientoInstructor
      ? new Date(instructorData.fechanacimientoInstructor)
        .toISOString()
        .split("T")[0]
      : "";

    setDocumentoInstructor(instructorData.documentoInstructor || "");
    setTipodocumentoInstructor(instructorData.tipodocumentoInstructor || "");
    setNombre1Instructor(instructorData.nombre1Instructor || "");
    setNombre2Instructor(instructorData.nombre2Instructor || "");
    setApellido1Instructor(instructorData.apellido1Instructor || "");
    setApellido2Instructor(instructorData.apellido2Instructor || "");
    setFechanacimientoInstructor(fechaNacimiento);
    setEdadInstructor(instructorData.edadInstructor || "");
    setSexoInstructor(instructorData.sexoInstructor || "");
    setRhInstructor(instructorData.rhInstructor || "");
    setEmailInstructor(instructorData.emailInstructor || "");
    setTelefono1Instructor(instructorData.telefono1Instructor || "");
    setTelefono2Instructor(instructorData.telefono2Instructor || "");
    setDireccionInstructor(instructorData.direccionInstructor || "");
    setPaisInstructor(instructorData.paisInstructor || "");
    setEstadoInstructor(instructorData.estadoInstructor || "");
    setCiudadInstructor(instructorData.ciudadInstructor || "");

    if (esSuperAdmin) {
      setRolObjectId(
        instructorData.rolObjectId?._id || instructorData.rolObjectId || ""
      );
    }

    if (instructorData.imgInstructor) {
      setPreview(instructorData.imgInstructor);
      previewRef.current = instructorData.imgInstructor;
    }

    const paisesData = await geografiaFunciones.obtenerPaises();
    if (!isMounted) return;

    const paisesLimpios = quitarDuplicadosPorNombre(paisesData, "nombrePais");
    setPaises(paisesLimpios);

    if (instructorData.paisInstructor) {
      const estadosData = await geografiaFunciones.obtenerEstadosPorPais(
        instructorData.paisInstructor
      );

      if (!isMounted) return;

      const estadosLimpios = quitarDuplicadosPorNombre(
        estadosData,
        "nombreEstado"
      );

      setEstados(estadosLimpios);
      setPaisSeleccionado(String(instructorData.paisInstructor));
    }

    if (instructorData.estadoInstructor) {
      const ciudadesData = await geografiaFunciones.obtenerCiudadesPorEstado(
        instructorData.estadoInstructor
      );

      if (!isMounted) return;

      const ciudadesLimpias = quitarDuplicadosPorNombre(
        ciudadesData,
        "nombreCiudad"
      );

      setCiudades(ciudadesLimpias);
      setEstadoSeleccionado(String(instructorData.estadoInstructor));
    }

    if (instructorData.ciudadInstructor) {
      setCiudadSeleccionada(String(instructorData.ciudadInstructor));
    }
  };

  useEffect(() => {
    const cargarRoles = async () => {
      if (!esSuperAdmin) return;

      try {
        setLoadingRoles(true);

        const { data } = await axios.get("/api/seguridad/roles/list", {
          headers: getHeaders(),
        });

        if (data?.ok) {
          setRoles(Array.isArray(data.roles) ? data.roles : []);
        }
      } catch (error) {
        console.error(
          "Error al cargar roles:",
          error.response?.data || error.message
        );
      } finally {
        setLoadingRoles(false);
      }
    };

    if (!verificandoSesion) cargarRoles();
  }, [esSuperAdmin, verificandoSesion]);

  useEffect(() => {
    const cargarPaises = async () => {
      try {
        setPaises([]);

        const paisesData = await geografiaFunciones.obtenerPaises();
        const paisesLimpios = quitarDuplicadosPorNombre(paisesData, "nombrePais");

        setPaises(paisesLimpios);
      } catch (error) {
        console.error("Error al cargar países:", error);
      }
    };

    if (!edit) cargarPaises();
  }, [edit]);

  useEffect(() => {
    let isMounted = true;

    const fetchInstructor = async () => {
      try {
        setLoading(true);

        const { data } = await axios.get(`/api/instructores/listid/${id}`, {
          headers: getHeaders(),
        });

        if (!data.ok) return;
        if (!isMounted) return;

        await cargarDatosInstructor(data.message || {}, isMounted);
      } catch (error) {
        if (!isMounted) return;

        console.error(
          "Error al obtener instructor:",
          error.response?.data || error.message
        );

        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            error.response?.data?.message || "No se pudo cargar el instructor",
          showConfirmButton: false,
          timer: 1800,
        });
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    if (id && !verificandoSesion) fetchInstructor();

    return () => {
      isMounted = false;
    };
  }, [id, verificandoSesion, esSuperAdmin]);

  const saveInstructor = async (formData) => {
    try {
      setLoading(true);

      await axios.post("/api/instructores/add", formData, {
        headers: {
          ...getHeaders(),
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: ({ loaded, total }) => {
          const percent = total ? parseInt((loaded * 100) / total) : 0;
          setUploadState(percent);
        },
      });

      cleanData();

      Swal.fire({
        icon: "success",
        title: "El Instructor ha sido registrado con éxito",
        showConfirmButton: false,
        timer: 1500,
      }).then(() => navigate("/instructor"));
    } catch (error) {
      console.error(
        "Error en saveInstructor:",
        error.response?.data || error.message
      );

      Swal.fire({
        icon: "error",
        title: "Error al registrar",
        text: error.response?.data?.message || "Intenta de nuevo",
      });
    } finally {
      setLoading(false);
    }
  };

  const updateInstructor = async (formData) => {
    try {
      setLoading(true);

      const { data } = await axios.put(
        `/api/instructores/update/${id}`,
        formData,
        {
          headers: {
            ...getHeaders(),
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: ({ loaded, total }) => {
            const percent = total ? parseInt((loaded * 100) / total) : 0;
            setUploadState(percent);
          },
        }
      );

      Swal.fire({
        icon: "success",
        title: data.message || "El Instructor ha sido actualizado con éxito",
        showConfirmButton: false,
        timer: 1500,
      }).then(() => navigate(-1));
    } catch (error) {
      console.error(
        "Error en updateInstructor:",
        error.response?.data || error.message
      );

      Swal.fire({
        icon: "error",
        title: "Error en la actualización",
        text: error.response?.data?.message || "Intenta de nuevo",
      });
    } finally {
      setLoading(false);
    }
  };

  const actions = async (e) => {
    e.preventDefault();

    if (!tienePermisoFormulario) {
      Swal.fire(
        "Sin permisos",
        edit
          ? "No tiene permisos para actualizar instructores."
          : "No tiene permisos para crear instructores.",
        "warning"
      );
      return;
    }

    if (esSuperAdmin && !rolObjectId) {
      Swal.fire({
        icon: "warning",
        title: "Rol requerido",
        text: "Debes seleccionar un rol para el instructor.",
      });
      return;
    }

    if (!edit && !passwordInstructor.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Contraseña requerida",
        text: "Debes ingresar una contraseña para el instructor.",
      });
      return;
    }

    if (
      (passwordInstructor || confirmPasswordInstructor) &&
      passwordInstructor !== confirmPasswordInstructor
    ) {
      Swal.fire({
        icon: "warning",
        title: "Contraseñas diferentes",
        text: "La contraseña y la confirmación no coinciden.",
      });
      return;
    }

    const formData = new FormData();

    if (image) {
      formData.append("imgInstructor", image);
    }

    const instructorData = {
      documentoInstructor,
      tipodocumentoInstructor,
      nombre1Instructor,
      nombre2Instructor: nombre2Instructor ?? "",
      apellido1Instructor,
      apellido2Instructor: apellido2Instructor ?? "",
      edadInstructor: edadInstructor ?? 0,
      sexoInstructor: sexoInstructor ?? "",
      direccionInstructor: direccionInstructor ?? "",
      telefono1Instructor,
      telefono2Instructor: telefono2Instructor ?? "",
      fechanacimientoInstructor: fechanacimientoInstructor ?? "",
      rhInstructor: rhInstructor ?? "",
      emailInstructor,
      paisInstructor: paisSeleccionado || paisInstructor || 0,
      estadoInstructor: estadoSeleccionado || estadoInstructor || 0,
      ciudadInstructor: ciudadSeleccionada || ciudadInstructor || 0,
    };

    if (esSuperAdmin) {
      instructorData.rolObjectId = rolObjectId;
    }

    if (!edit || passwordInstructor.trim()) {
      instructorData.passwordInstructor = passwordInstructor;
    }

    Object.entries(instructorData).forEach(([key, value]) => {
      formData.append(key, value);
    });

    if (edit) {
      updateInstructor(formData);
    } else {
      saveInstructor(formData);
    }
  };

  const handlePaisChange = async (paisId) => {
    try {
      setPaisSeleccionado(paisId);
      setPaisInstructor(paisId);
      setEstados([]);
      setCiudades([]);
      setEstadoSeleccionado("");
      setCiudadSeleccionada("");
      setEstadoInstructor("");
      setCiudadInstructor("");

      if (paisId) {
        const estadosData = await geografiaFunciones.obtenerEstadosPorPais(paisId);

        const estadosLimpios = quitarDuplicadosPorNombre(
          estadosData,
          "nombreEstado"
        );

        setEstados(estadosLimpios);
      }
    } catch (error) {
      console.error("Error al cambiar el país:", error);
    }
  };

  const handleEstadoChange = async (estadoId) => {
    try {
      setEstadoSeleccionado(estadoId);
      setEstadoInstructor(estadoId);
      setCiudades([]);
      setCiudadSeleccionada("");
      setCiudadInstructor("");

      if (estadoId) {
        const ciudadesData =
          await geografiaFunciones.obtenerCiudadesPorEstado(estadoId);

        const ciudadesLimpias = quitarDuplicadosPorNombre(
          ciudadesData,
          "nombreCiudad"
        );

        setCiudades(ciudadesLimpias);
      }
    } catch (error) {
      console.error("Error al cambiar el estado:", error);
    }
  };

  const handleCiudadChange = (ciudadId) => {
    setCiudadSeleccionada(ciudadId);
    setCiudadInstructor(ciudadId);
  };

  const handleFileChange = async (e) => {
    try {
      if (!e.target.files || !e.target.files[0]) return;

      const file = e.target.files[0];
      const processed = await normalizeImage(file);

      if (preview && preview.startsWith("blob:")) {
        try {
          URL.revokeObjectURL(preview);
        } catch (err) { }
      }

      setImage(processed);

      const blobUrl = URL.createObjectURL(processed);
      setPreview(blobUrl);
      previewRef.current = blobUrl;

      const label = document.getElementById("fileLabel");
      const fileNameInput = document.getElementById("fileName");

      if (fileNameInput) fileNameInput.value = processed.name || "imagen.jpg";
      if (label) label.textContent = "Seleccionar / Cambiar";
    } catch (err) {
      console.error("Error procesando imagen:", err);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo procesar la imagen.",
      });
    }
  };

  if (verificandoSesion) {
    return (
      <div className="container py-5">
        <div className="text-center">
          <div className="spinner-border text-dark" />
          <p className="mt-3 text-secondary">Verificando sesión...</p>
        </div>
      </div>
    );
  }

  if (edit && !puedeActualizar) {
    return (
      <div className="container py-5">
        <div className="alert alert-warning">
          No tiene permisos para actualizar instructores.
        </div>

        <button
          className="btn btn-dark"
          onClick={() => navigate("/instructor/")}
        >
          Volver
        </button>
      </div>
    );
  }

  if (!edit && !puedeCrear) {
    return (
      <div className="container py-5">
        <div className="alert alert-warning">
          No tiene permisos para registrar instructores.
        </div>

        <button
          className="btn btn-dark"
          onClick={() => navigate("/instructor/")}
        >
          Volver
        </button>
      </div>
    );
  }

  return (
    <div>
      <div className="container-fluid px-2 px-md-4">
        <div className="bg-white border rounded-4 shadow-sm p-3 p-md-4 mb-3">
          <div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
            <div>
              <h4 className="mb-1 fw-semibold">
                {edit ? "Actualizar Instructor" : "Registrar Instructor"}
              </h4>

              <p className="mb-0 text-secondary small">
                Completa los datos. Campos con{" "}
                <span className="fw-semibold">*</span> son obligatorios.
              </p>
            </div>

            <div className="d-flex gap-2 flex-wrap">
              <button
                type="button"
                className="btn btn-outline-dark"
                onClick={() => navigate(-1)}
                disabled={loading}
              >
                <i className="fa-solid fa-arrow-rotate-left me-2"></i>
                Volver
              </button>

              <button
                type="button"
                className={`btn ${edit ? "btn-outline-danger" : "btn-outline-dark"
                  }`}
                onClick={handleCancelOrClean}
                disabled={loading}
              >
                <i
                  className={`fa-solid ${edit ? "fa-xmark" : "fa-eraser"
                    } me-2`}
                ></i>
                {edit ? "Cancelar" : "Limpiar"}
              </button>
            </div>
          </div>
        </div>

        <form onSubmit={actions}>
          <div className="row g-4">
            <div className="col-12 col-lg-9">
              <div className="bg-white border rounded-4 shadow-sm p-3 p-md-4 mb-3">
                <h6 className="mb-0 fw-semibold">Datos personales</h6>
                <hr className="my-3" />

                <div className="row g-3">
                  <InputTexto
                    label="Nombre 1 *"
                    value={nombre1Instructor}
                    setValue={setNombre1Instructor}
                    required
                  />

                  <InputTexto
                    label="Nombre 2"
                    value={nombre2Instructor}
                    setValue={setNombre2Instructor}
                  />

                  <InputTexto
                    label="Apellido 1 *"
                    value={apellido1Instructor}
                    setValue={setApellido1Instructor}
                    required
                  />

                  <InputTexto
                    label="Apellido 2"
                    value={apellido2Instructor}
                    setValue={setApellido2Instructor}
                  />

                  <div className="col-12 col-md-6">
                    <label className="form-label small text-secondary text-uppercase">
                      Tipo de documento *
                    </label>

                    <select
                      className="form-select"
                      value={tipodocumentoInstructor}
                      onChange={(e) =>
                        setTipodocumentoInstructor(e.target.value)
                      }
                      required
                    >
                      <option value="">Seleccione un tipo</option>
                      <option value="CC">Cédula de Ciudadanía</option>
                      <option value="TI">Tarjeta de Identidad</option>
                      <option value="CE">Cédula de Extranjería</option>
                      <option value="PAS">Pasaporte</option>
                    </select>
                  </div>

                  <InputTexto
                    label="Número de documento *"
                    value={documentoInstructor}
                    setValue={setDocumentoInstructor}
                    required
                    col="col-12 col-md-6"
                  />

                  <div className="col-12 col-md-3">
                    <label className="form-label small text-secondary text-uppercase">
                      Fecha de nacimiento *
                    </label>

                    <input
                      type="date"
                      className="form-control"
                      value={fechanacimientoInstructor}
                      onChange={(e) =>
                        setFechanacimientoInstructor(e.target.value)
                      }
                      required
                    />
                  </div>

                  <SelectSimple
                    label="Edad"
                    value={edadInstructor}
                    setValue={setEdadInstructor}
                    opciones={edades}
                  />

                  <div className="col-6 col-md-3">
                    <label className="form-label small text-secondary text-uppercase">
                      Sexo *
                    </label>

                    <select
                      className="form-select"
                      value={sexoInstructor}
                      onChange={(e) => setSexoInstructor(e.target.value)}
                      required
                    >
                      <option value="">Seleccione</option>

                      {sexos.map((sexo, idx) => (
                        <option key={idx} value={sexo.valor}>
                          {sexo.etiqueta}
                        </option>
                      ))}
                    </select>
                  </div>

                  <SelectSimple
                    label="RH *"
                    value={rhInstructor}
                    setValue={setRhInstructor}
                    opciones={gruposSanguineos}
                    required
                  />
                </div>
              </div>

              <div className="bg-white border rounded-4 shadow-sm p-3 p-md-4 mb-3">
                <h6 className="mb-0 fw-semibold">Contacto y acceso</h6>
                <hr className="my-3" />

                <div className="row g-3">
                  <InputTexto
                    label="Dirección *"
                    value={direccionInstructor}
                    setValue={setDireccionInstructor}
                    required
                    col="col-12 col-md-6"
                  />

                  <InputTexto
                    label="Correo electrónico / Usuario *"
                    value={emailInstructor}
                    setValue={setEmailInstructor}
                    required
                    type="email"
                    col="col-12 col-md-6"
                  />

                  <InputTexto
                    label="Teléfono 1 *"
                    value={telefono1Instructor}
                    setValue={setTelefono1Instructor}
                    required
                    type="tel"
                    col="col-12 col-md-6"
                  />

                  <InputTexto
                    label="Teléfono 2"
                    value={telefono2Instructor}
                    setValue={setTelefono2Instructor}
                    type="tel"
                    col="col-12 col-md-6"
                  />

                  {puedeAsignarRoles && (
                    <>
                      <div className="col-12 col-md-6">
                        <label className="form-label small text-secondary text-uppercase">
                          Rol *
                        </label>

                        <select
                          className="form-select"
                          value={rolObjectId}
                          onChange={(e) => setRolObjectId(e.target.value)}
                          required
                          disabled={loadingRoles}
                        >
                          <option value="">
                            {loadingRoles
                              ? "Cargando roles..."
                              : "Seleccione un rol"}
                          </option>

                          {roles.map((rol) => (
                            <option key={rol._id} value={rol._id}>
                              {rol.nombreRol}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-12 col-md-6">
                        <div className="alert alert-light border mb-0 small text-secondary h-100 d-flex align-items-center">
                          <div>
                            <i className="fa-solid fa-user-lock me-2"></i>
                            El correo será el usuario de acceso al sistema y el
                            rol definirá sus permisos.
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  <div className="col-12 col-md-6">
                    <label className="form-label small text-secondary text-uppercase">
                      {edit ? "Nueva contraseña" : "Contraseña *"}
                    </label>

                    <div className="input-group">
                      <input
                        type={mostrarPassword ? "text" : "password"}
                        className="form-control"
                        value={passwordInstructor}
                        onChange={(e) =>
                          setPasswordInstructor(e.target.value)
                        }
                        required={!edit}
                        placeholder={
                          edit
                            ? "Dejar vacío para conservar la actual"
                            : "Contraseña"
                        }
                      />

                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => setMostrarPassword(!mostrarPassword)}
                      >
                        <i
                          className={`fa-solid ${mostrarPassword ? "fa-eye-slash" : "fa-eye"
                            }`}
                        ></i>
                      </button>
                    </div>
                  </div>

                  <div className="col-12 col-md-6">
                    <label className="form-label small text-secondary text-uppercase">
                      {edit
                        ? "Confirmar nueva contraseña"
                        : "Confirmar contraseña *"}
                    </label>

                    <div className="input-group">
                      <input
                        type={mostrarConfirmPassword ? "text" : "password"}
                        className="form-control"
                        value={confirmPasswordInstructor}
                        onChange={(e) =>
                          setConfirmPasswordInstructor(e.target.value)
                        }
                        required={!edit}
                      />

                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() =>
                          setMostrarConfirmPassword(!mostrarConfirmPassword)
                        }
                      >
                        <i
                          className={`fa-solid ${mostrarConfirmPassword ? "fa-eye-slash" : "fa-eye"
                            }`}
                        ></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white border rounded-4 shadow-sm p-3 p-md-4">
                <h6 className="mb-0 fw-semibold">Expedición del Documento</h6>
                <hr className="my-3" />

                <div className="row g-3">
                  <div className="col-12 col-md-4">
                    <label className="form-label small text-secondary text-uppercase">
                      País
                    </label>

                    <select
                      className="form-select"
                      onChange={(e) => handlePaisChange(e.target.value)}
                      value={paisSeleccionado || paisInstructor || ""}
                    >
                      <option value="">Seleccione un país</option>

                      {paisesOrdenados.map((pais) => (
                        <option key={pais.idPais} value={pais.idPais}>
                          {pais.nombrePais}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-12 col-md-4">
                    <label className="form-label small text-secondary text-uppercase">
                      Estado
                    </label>

                    <select
                      className="form-select"
                      onChange={(e) => handleEstadoChange(e.target.value)}
                      value={estadoSeleccionado || estadoInstructor || ""}
                      disabled={!paisSeleccionado && !paisInstructor}
                    >
                      <option value="">Seleccione un estado</option>

                      {estadosOrdenados.map((estado) => (
                        <option key={estado.idEstado} value={estado.idEstado}>
                          {estado.nombreEstado}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-12 col-md-4">
                    <label className="form-label small text-secondary text-uppercase">
                      Ciudad
                    </label>

                    <select
                      className="form-select"
                      onChange={(e) => handleCiudadChange(e.target.value)}
                      value={ciudadSeleccionada || ciudadInstructor || ""}
                      disabled={!estadoSeleccionado && !estadoInstructor}
                    >
                      <option value="">Seleccione una ciudad</option>

                      {ciudadesOrdenadas.map((ciudad) => (
                        <option key={ciudad.idCiudad} value={ciudad.idCiudad}>
                          {String(ciudad.nombreCiudad || "").trim()}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {loading && (
                  <div className="mt-4">
                    <div className="d-flex justify-content-between">
                      <small className="text-secondary">Subiendo…</small>
                      <small className="text-secondary fw-semibold">
                        {uploadState}%
                      </small>
                    </div>

                    <div className="progress mt-2" style={{ height: 10 }}>
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{ width: `${uploadState}%` }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="col-12 col-lg-3">
              <div className="sticky-top" style={{ top: 16 }}>
                <div className="bg-white border rounded-4 shadow-sm p-3 p-md-4">
                  <div className="d-flex justify-content-between align-items-center">
                    <h6 className="mb-0 fw-semibold">Fotografía</h6>
                    <span className="badge text-bg-light border text-secondary rounded-pill">
                      Opcional
                    </span>
                  </div>

                  <hr className="my-3" />

                  <div className="border rounded-4 overflow-hidden bg-white">
                    <div
                      className="d-flex align-items-center justify-content-center"
                      style={{ height: 420 }}
                    >
                      {preview !== "" ? (
                        <img
                          src={preview}
                          alt="Vista previa"
                          className="w-100 h-100"
                          style={{ objectFit: "cover" }}
                        />
                      ) : (
                        <div className="text-center text-secondary px-3">
                          <div className="fs-1 mb-2">👤</div>
                          <div className="fw-semibold">Sin imagen</div>
                          <div className="small">
                            Selecciona una fotografía
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="mt-3">
                    <input
                      type="file"
                      id="fileInput"
                      name="imgInstructor"
                      className="d-none"
                      accept="image/*"
                      capture="environment"
                      onChange={handleFileChange}
                    />

                    <div className="input-group">
                      <span className="input-group-text bg-white text-secondary">
                        Archivo
                      </span>

                      <input
                        type="text"
                        id="fileName"
                        className="form-control text-secondary"
                        placeholder="Ningún archivo seleccionado"
                        readOnly
                      />
                    </div>

                    <label
                      id="fileLabel"
                      htmlFor="fileInput"
                      className="btn btn-outline-secondary w-100 mt-2 fw-semibold"
                    >
                      Seleccionar / Cambiar
                    </label>
                  </div>
                </div>

                <div className="mt-3 bg-white border rounded-4 shadow-sm p-3">
                  <div className="small text-secondary">
                    <i className="fa-regular fa-circle-check me-2"></i>
                    La imagen se optimiza automáticamente antes de enviarse.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row g-3 mt-4">
            <div className="col-12 col-md-6">
              <button
                type="submit"
                className="btn btn-dark w-100 fw-semibold py-2"
                disabled={loading || !tienePermisoFormulario}
              >
                {loading
                  ? "Guardando..."
                  : edit
                    ? "Guardar cambios"
                    : "Registrar"}
              </button>
            </div>

            <div className="col-12 col-md-6">
              <button
                type="button"
                className={`btn w-100 fw-semibold py-2 ${edit ? "btn-outline-danger" : "btn-outline-secondary"
                  }`}
                onClick={handleCancelOrClean}
                disabled={loading}
              >
                {edit ? "Cancelar" : "Limpiar"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

const InputTexto = ({
  label,
  value,
  setValue,
  required = false,
  type = "text",
  col = "col-12 col-md-6 col-xl-3",
}) => (
  <div className={col}>
    <label className="form-label small text-secondary text-uppercase">
      {label}
    </label>

    <input
      type={type}
      className="form-control"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      required={required}
    />
  </div>
);

const SelectSimple = ({
  label,
  value,
  setValue,
  opciones = [],
  required = false,
}) => (
  <div className="col-6 col-md-3">
    <label className="form-label small text-secondary text-uppercase">
      {label}
    </label>

    <select
      className="form-select"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      required={required}
    >
      <option value="">Seleccione</option>

      {opciones.map((opcion) => (
        <option key={opcion} value={opcion}>
          {opcion}
        </option>
      ))}
    </select>
  </div>
);

export default RegistrarInstructores;